export default "__VITE_ASSET__88c765df__"